import { createRoot, type Root } from "react-dom/client";
import Home from "../pages/Home/Home";
import "../index.css";
import "../pages/Home/Home.module.css";

let root: Root | null = null;

function mount(element: HTMLElement) {
  if (root) {
    return;
  }

  root = createRoot(element);
  root.render(<Home />);
}

function unmount() {
  root?.unmount();
  root = null;
}

window.ACADHome = { mount, unmount };

function boot() {
  const element = document.getElementById("home-root");
  if (element) {
    mount(element);
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
  boot();
}
